import React from 'react';
import { Hero } from './sections/Hero';
import { WhatBCBHDoes } from './sections/WhatBCBHDoes';
import { FeaturedItems } from './sections/FeaturedItems';
import { HowHubWorks } from './sections/HowHubWorks';
import { PortalRoadmap } from './sections/PortalRoadmap';
import { PartnersPreview } from './sections/PartnersPreview';
import { LatestNews } from './sections/LatestNews';
import { GetInTouch } from './sections/GetInTouch';

export const Home: React.FC = () => {
  return (
    <>
      <Hero />
      <WhatBCBHDoes />
      <FeaturedItems />
      <HowHubWorks />
      <PortalRoadmap />
      <PartnersPreview />
      <LatestNews />
      <GetInTouch />
    </>
  );
};

